import { render, staticRenderFns } from "./arealist.vue?vue&type=template&id=22b5f0da"
import script from "./arealist.vue?vue&type=script&lang=js"
export * from "./arealist.vue?vue&type=script&lang=js"
import style0 from "./arealist.vue?vue&type=style&index=0&id=22b5f0da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports